import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/fe-silangit-app/src/components/common/quiz.jsx");
